import { jsx as _jsx } from "react/jsx-runtime";
import { BtnFactory, SIZE } from './BtnFactory';
export { SIZE };
export function SecondaryBtn(props) {
    return _jsx(BtnFactory, { as: 'button', severity: 'secondary', ...props });
}
//# sourceMappingURL=SecondaryBtn.js.map